"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var styled_components_1 = tslib_1.__importStar(require("../../../theme/styled-components"));

var icons_1 = tslib_1.__importDefault(require("./icons"));

var Wrapper = styled_components_1["default"].span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n"], ["\n  display: inline-flex;\n  align-items: center;\n  flex-shrink: 0;\n"])));
var defaultProps = {
  size: 'm'
};

var Icon =
/** @class */
function (_super) {
  tslib_1.__extends(Icon, _super);

  function Icon() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Icon.prototype.sizeToPx = function (size) {
    var sizeMapping = {
      xs: 8,
      s: 12,
      m: 16,
      l: 24,
      xl: 40,
      xxl: 110
    };
    return typeof size === 'string' && size in sizeMapping ? sizeMapping[size] : sizeMapping.m;
  };

  Icon.prototype.render = function () {
    var _a = this.props,
        size = _a.size,
        color = _a.color,
        className = _a.className,
        name = _a.name,
        restProps = tslib_1.__rest(_a, ["size", "color", "className", "name"]);

    var iconSize = typeof size === 'string' ? this.sizeToPx(size) : size;
    var iconColor = String(this.props.color ? color : this.props.theme.textColor);
    return react_1["default"].createElement(Wrapper, tslib_1.__assign({
      className: "icon " + (className || '')
    }, restProps), name in icons_1["default"] ? icons_1["default"][name](iconSize, iconColor) : null);
  };

  Icon.defaultProps = defaultProps;
  return Icon;
}(react_1["default"].PureComponent);

exports["default"] = styled_components_1.withTheme(Icon);

var icons_2 = require("./icons");

tslib_1.__createBinding(exports, icons_2, "default", "icons");

var templateObject_1;